/**
 * Enum of select strategies for DataTable.
 */
export enum SelectStrategy {
  All = 'all',
  Page = 'page',
  Single = 'single'
}
